import { render, staticRenderFns } from "./SmsCampaings.vue?vue&type=template&id=497a20ae"
import script from "./SmsCampaings.vue?vue&type=script&lang=js"
export * from "./SmsCampaings.vue?vue&type=script&lang=js"
import style0 from "./SmsCampaings.vue?vue&type=style&index=0&id=497a20ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports